export default __webpack_public_path__ + "static/media/icon-serious-face-full.873e0054.svg";